import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-capitalize-first" }
const _hoisted_2 = { class: "d-flex align-items-start" }
const _hoisted_3 = { class: "input-group-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    modelValue: _ctx.deal !== null,
    "header-class": "d-none",
    "footer-class": "d-flex justify-content-between",
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ($event === false && (_ctx.deal = null)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("h5", _hoisted_1, _toDisplayString(_ctx.helper.trans('labels.change_payout_amount')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_FormInputWrapper, {
          class: "flex-grow-1",
          errors: _ctx.errors
        }, {
          default: _withCtx((parentProps) => [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", parentProps.class]),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.amount) = $event)),
              onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.onOkClick()), ["prevent"]), ["enter"]))
            }, null, 34), [
              [_vModelText, _ctx.form.amount]
            ])
          ]),
          _: 1
        }, 8, ["errors"]),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.deal?.takerSum.currency), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deal = null)),
        class: "btn btn-outline-dark btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
      _createVNode(_component_LoaderWrapper, {
        ref: "loader",
        zoom: 0.5
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onOkClick())),
            class: "btn btn-outline-primary btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans('button.save')), 1)
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}